module.exports = __webpack_public_path__ + "images/pro/icon-pro-downgrade@2x-56789abf6860a9b260545aa7d3507e98.png";